import * as React from 'react';
import { ChevronLeft } from 'lucide-react';
import { cn } from '../../lib/utils';
import { Button } from '../ui/button';

export interface PageHeaderProps
  extends React.HTMLAttributes<HTMLDivElement> {
  title: string;
  subtitle?: string;
  icon?: React.ReactNode;
  actions?: React.ReactNode;
  backHref?: string;
  onBack?: () => void;
}

const PageHeader = React.forwardRef<HTMLDivElement, PageHeaderProps>(
  (
    {
      title,
      subtitle,
      icon,
      actions,
      backHref,
      onBack,
      className,
      ...props
    },
    ref,
  ) => {
    return (
      <div
        ref={ref}
        className={cn(
          'border-b border-[var(--color-border)] bg-[var(--color-background)] px-6 py-4',
          className,
        )}
        {...props}
      >
        <div className="flex items-center justify-between gap-4">
          <div className="flex flex-1 items-start gap-4">
            {backHref || onBack ? (
              <Button
                variant="ghost"
                size="icon"
                onClick={onBack}
                asChild={!onBack && !!backHref}
              >
                {backHref ? (
                  <a href={backHref}>
                    <ChevronLeft className="h-4 w-4" />
                  </a>
                ) : (
                  <ChevronLeft className="h-4 w-4" />
                )}
              </Button>
            ) : null}
            <div className="flex flex-1 items-center gap-3">
              {icon && (
                <div className="text-[var(--color-foreground)]">{icon}</div>
              )}
              <div className="flex-1">
                <h1 className="text-3xl font-bold tracking-tight text-[var(--color-foreground)]">
                  {title}
                </h1>
                {subtitle && (
                  <p className="text-sm text-[var(--color-muted-foreground)]">
                    {subtitle}
                  </p>
                )}
              </div>
            </div>
          </div>
          {actions && (
            <div className="flex items-center gap-2">
              {actions}
            </div>
          )}
        </div>
      </div>
    );
  },
);

PageHeader.displayName = 'PageHeader';

export { PageHeader };
